<template>
<div>
    <h1>PlattelandsTV - Ark van Noë - 2022</h1>
    <p>
        In 2022 heeft het team van PlattelandsTV een vervolg reportage gemaakt over de Belgische Mastiff.
    </p>
    <a href="https://www.plattelandstv.be" target="_blank">www.plattelandstv.be</a>
    <video width="960" height="720" controls>
        <source :src="platteland2022" type="video/mp4">
        Uw browser ondersteunt geen video.
    </video>

    <h1>PlattelandsTV - Beestig - 2022</h1>
    <p>
        Het team van PlattelandsTV heeft een beknopte samenvatting van het ras gemaakt voor hun repubriek "Beestig".
    </p>
    <a href="https://www.plattelandstv.be" target="_blank">www.plattelandstv.be</a>
    <video width="960" height="720" controls>
        <source :src="plattelandBeestig" type="video/mp4">
        Uw browser ondersteunt geen video.
    </video>

    <h1>PlattelandsTV - Ark van Noë - 2017</h1>
    <p>
        In maart 2017 heeft het team van PlattelandsTV een reportage gemaakt over de Belgische Mastiff.
    </p>
    <p>
        In de reportage wordt het voorkomen van de hond en het gedrag ervan toegelicht. Daarnaast schetst men kort het verleden en wordt er een blik op de toekomst geworpen.
    </p>
    <a href="https://www.plattelandstv.be" target="_blank">www.plattelandstv.be</a>
    <video width="960" height="720" controls>
        <source :src="platteland2017" type="video/mp4">
        Uw browser ondersteunt geen video.
    </video>

</div>
</template>

<script>
export default {
    name: 'Plattelands',
    data: function() {
        return {
            platteland2017: process.env.VUE_APP_VIDEO_URL + '/plattelandstv-2017.mp4',
            platteland2022: process.env.VUE_APP_VIDEO_URL + '/plattelandstv-2022.mp4',
            plattelandBeestig: process.env.VUE_APP_VIDEO_URL + '/plattelandstv-beestig.mp4',
        }
    }
}
</script>

<style scoped>
h1 {
    margin-top: 1em;
    color: #016F70;
    font-weight: 600;
    font-size: 1.3em;
}
video {
    margin-top: 16px;
    width: 100%;
}
p {
    margin-bottom: 16px;
}
</style>
